import React, { useRef, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Form, Accordion } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SearchableDropdown from "../../Component/SearchableDropdown";
import Attachments from "../../Component/TemplateAttachments";

import Header from "../../Component/Header";
import placeholderImg from "../../Asset/Images/circle-placeholder.svg";
import placeholderImgLarge from "../../Asset/Images/placeholder-large-icon.png";
import plusIcon from "../../Asset/Images/plus-icon.svg";
import deleteIcon from "../../Asset/Images/delete-icon.svg";
import attachmentIcon from "../../Asset/Images/attachment-icon.svg";
import downArrowIcon from "../../Asset/Images/down-arrow-icon.svg";
import crossIcon from "../../Asset/Images/cross-icon.svg";

import messageIcon from "../../Asset/Images/message-icon.svg";
import checkIcon from "../../Asset/Images/check-circle-green-icon.svg";
import crossIconWeb from "../../Asset/Images/crose-grey-circle-icon.svg";

import SubHeader from "../../Component/SubHeader";
import Modal from "react-bootstrap/Modal";
import FullScreenLoader from "../../Component/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import MobileFooter from "../../Component/MobileFooter";

import {
  postDeploy,
  getParts,
  uploadImg,
  getLocations,
  getEmails,
  getRequestById,
  updateStatus,
  updateRequest,
  deleteAsset,
  getRigOptions,
  getAssetByRig,
} from "../../Services/deploy";

import "./index.css";
// import "./Release.assets.css";

// ---- Shared allowed image MIME types ----
const ALLOWED_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
  "image/gif",
];
const ALLOWED_IMAGE_ACCEPT = "image/png, image/jpeg, image/jpg, image/webp, image/gif";

const ASSET_STATUS_OPTIONS = [
  "Inspect",
  "Shipping",
  "Reserved",
  "Available",
  "Internal Use",
  "Repair",
];

// ---- Helper: build a usable URL for previewing an asset image ----
const BASE_URL = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

const buildAssetPreviewUrl = (raw) => {
  if (!raw || typeof raw !== "string") return "";
  const s = raw.trim();
  if (!s) return "";
  if (
    s.startsWith("http://") ||
    s.startsWith("https://") ||
    s.startsWith("blob:") ||
    s.startsWith("data:")
  ) {
    return s;
  }
  const cleanPath = s.replace(/^\/+/, "");
  return BASE_URL ? `${BASE_URL}/${cleanPath}` : s;
};

// ---- Helper: coerce any API value into a primitive option { value, label } ----
// Returns null when nothing usable can be extracted.
const toPrimitiveOption = (item, extraKeyCandidates = []) => {
  if (item === null || item === undefined) return null;

  // Plain primitive (string / number)
  if (typeof item === "string" || typeof item === "number") {
    const label = String(item);
    if (!label.trim()) return null;
    return { value: label, label };
  }

  // Object — try a set of well-known keys
  if (typeof item === "object") {
    const candidates = [
      ...extraKeyCandidates,
      "JobName",
      "Jobname",
      "job_name",
      "AssetNo",
      "AssetNumber",
      "Location",
      "Name",
      "name",
      "label",
      "value",
    ];
    for (const k of candidates) {
      const raw = item[k];
      if (typeof raw === "string" || typeof raw === "number") {
        const label = String(raw);
        if (label.trim()) return { value: label, label };
      }
    }
  }

  return null;
};

// ---- Helper: dedupe an array of { value, label } by label ----
const dedupeOptions = (options) => {
  const seen = new Set();
  const out = [];
  for (const opt of options) {
    if (!opt) continue;
    const key = `${opt.value}::${opt.label}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(opt);
  }
  return out;
};

function Release() {
  const { templateId } = useParams();
  let navigate = useNavigate();

  const fileInputRefs = useRef([]);
  const vehicleFrontRef = useRef(null);
  const vehicleBackRef = useRef(null);
  const vehicleSide1Ref = useRef(null);
  const vehicleSide2Ref = useRef(null);

  const initialLoadDoneRef = useRef(false);
  const prevRigRef = useRef(null);

  const [show, setShow] = useState(false);
  const [selectedPreview, setSelectedPreview] = useState(null);

  const [vehicleFrontimage, setVehicleFrontimage] = useState(null);
  const [vehicleBackimage, setVehicleBackimage] = useState(null);
  const [vehicleside1image, setVehicleside1image] = useState(null);
  const [vehicleside2image, setVehicleside2image] = useState(null);

  const [vehicleFrontPreview, setVehicleFrontPreview] = useState(null);
  const [vehicleBackPreview, setVehicleBackPreview] = useState(null);
  const [vehicleFrontName, setVehicleFrontName] = useState(null);
  const [vehicleBackName, setVehicleBackName] = useState(null);
  const [vehicleside1Preview, setVehicleside1Preview] = useState(null);
  const [vehicleside2Preview, setVehicleside2Preview] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [partsList, setPartsList] = useState([]);
  const [inputOptionList, setInputOptionList] = useState([]);
  const [rigOptionList, setRigOptionList] = useState([]);
  const [additionalEmail, setAdditionalEmail] = useState("");
  const [additionalEmailError, setAdditionalEmailError] = useState("");
  const [additionalEmails, setAdditionalEmails] = useState([]);
  const [userEmails, setUserEmails] = useState([]);
  const [status, setStaus] = useState("");
  const [additionalEmailsList, setAdditionalEmailsList] = useState([]);
  const [assetsFetched, setAssetsFetched] = useState(false);

  const [showVehiclePreview, setShowVehiclePreview] = useState(false);
  const [vehiclePreviewSrc, setVehiclePreviewSrc] = useState(null);
  const [vehiclePreviewName, setVehiclePreviewName] = useState("");
  const [openStatusDropdown, setOpenStatusDropdown] = useState(null);


  const [chargeBackCustomers, setChargeBackCustomers] = useState([
    { id: 0, name: "" },
  ]);

  const [formData, setFormData] = useState({
    rigNuber: "",
    laydown: "",
    addShipTo: "",
    note: "",
  });

  const [truckingToRig, setTruckingToRig] = useState({
    company: "",
    driverName: "",
    phone: "",
    bol: "",
    payforTruck: "",
    po: "",
  });

  const [additionaltruckingToRig, setAdditionaltruckingToRig] = useState({
    company: "",
    driverName: "",
    phone: "",
    bol: "",
    payforTruck: "",
    po: "",
  });

  let [assests, setAssets] = useState([]);

  const heading = "RELEASE: Rig/Jobsite => Basin/Laydown-Yard Shipments ";

  // ---- Central lock flag ----
  const isAdmin = localStorage.role === "Admin";
  const isCompleted = status === "Completed";
  const isLocked = templateId ? (!isAdmin || isCompleted) : false;
  const areAssetsLocked = Boolean(templateId) || isLocked;

  useEffect(() => {
    fetchParts();
    fetchEmail();
    fetchRigOptions();
    if (templateId) {
      fetchRequestDetails();
    }
    // eslint-disable-next-line
  }, []);

  // Cleanup any lingering toasts when this component unmounts
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);

  useEffect(() => {
    const rig = formData.rigNuber;
    const laydown = formData.laydown;

    if (!templateId) {
      if (!rig || !laydown) {
        setAssets([]);
        setAssetsFetched(false);
        return;
      }
      fetchAssetByRig();
      return;
    }

    if (!initialLoadDoneRef.current) {
      if (!rig || !laydown) {
        return;
      }
      initialLoadDoneRef.current = true;
      prevRigRef.current = rig;
      return;
    }

    const rigChanged = prevRigRef.current !== rig;
    prevRigRef.current = rig;

    if (rigChanged) {
      if (rig && laydown) {
        fetchAssetByRig();
      }
      return;
    }

    if (laydown && !templateId) {
      setAssets((prev) =>
        prev.map((asset) => ({
          ...asset,
          LaydownYard: laydown,
        }))
      );
    }
    // eslint-disable-next-line
  }, [formData.rigNuber, formData.laydown, templateId]);

  const rentalTicketNumber = assests.find(
    (asset) => String(asset.rentalTicketNo || "").trim()
  )?.rentalTicketNo;

  let handleComplete = async () => {
    let filteredAsset = (assests || [])
      .filter((item) => item.AssetNo != null && item.AssetNo !== "")
      .map((item) => ({
        AssetNo: item.AssetNo,
        LaydownYard: item?.LaydownYard ?? "",
        rentalTicketNo: item?.rentalTicketNo ?? "",
        Status: item?.Status ?? "Inspect",
      }));

    let payload = {
      RequestID: Number(templateId) || templateId,
      RequestType: "RELEASE",
      Status: "Completed",
      ActiveJobName: formData.rigNuber,
      ModifiedByUser: localStorage.name || "",
      Asset: filteredAsset,
    };

    setIsLoading(true);
    try {
      let res = await updateStatus(payload, localStorage.access_token);
      setIsLoading(false);

      if (res) {
        if (res.status === 200) {
          const successMsg =
            typeof res.data === "string"
              ? res.data
              : res?.data?.message || "Request marked as completed!";
          toast.dismiss();
          toast.success(successMsg, { autoClose: 3000 });
          fetchRequestDetails();
        } else {
          const errorMsg =
            res?.data?.message ||
            res?.data?.error ||
            (typeof res.data === "string" ? res.data : null) ||
            `Request failed (${res.status})`;
          toast.dismiss();
          toast.error(errorMsg, { autoClose: 5000 });
        }
      } else {
        toast.dismiss();
        toast.error("Internal server error!", { autoClose: 5000 });
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error marking request as complete:", error);

      const errorMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        (typeof error?.response?.data === "string"
          ? error.response.data
          : null) ||
        error?.message ||
        "Something went wrong. Please try again.";

      toast.dismiss();
      toast.error(errorMsg, { autoClose: 5000 });
    }
  };

  // ─── FIXED: rig options normalized to primitive { value, label } ───
  let fetchRigOptions = async () => {
    try {
      let res = await getRigOptions(localStorage.access_token);
      const rawList = Array.isArray(res?.data?.Jobname)
        ? res.data.Jobname
        : [];

      const options = rawList
        .map((item) => toPrimitiveOption(item, ["JobName", "Jobname", "job_name"]))
        .filter(Boolean);

      setRigOptionList(dedupeOptions(options));
    } catch (err) {
      console.error("Error fetching rig options:", err);
      setRigOptionList([]);
    }
  };

  let fetchAssetByRig = async () => {
    setIsLoading(true);
    setAssetsFetched(false);

    const payload = {
      job_name: formData.rigNuber,
      user_name: localStorage?.name,
    };

    try {
      const res = await getAssetByRig(localStorage.access_token, payload);

      const existingMap = new Map(
        (assests || []).map((a) => [String(a.AssetNo), a])
      );

      const temp = [];

      if (res?.data?.Result?.length) {
        res.data.Result.forEach((val, i) => {
          const prior = existingMap.get(String(val?.AssetNumber));

          const blobStr =
            typeof prior?.AssetBlob === "string" ? prior.AssetBlob : "";
          const fullUrl = buildAssetPreviewUrl(blobStr);

          temp.push({
            id: prior?.id ?? `fetched-${Date.now()}-${i}`,
            name: "S3S",
            img: fullUrl,
            imgName: prior?.imgName || "",
            imgPreview: fullUrl,
            value: "",
            AssetID: prior?.AssetID ?? null,
            AssetNo: val?.AssetNumber,
            rentalTicketNo:
              prior?.rentalTicketNo ?? val?.rentalTicketNo ?? "",
            Status:
              prior?.Status ?? val?.Status ?? val?.AssetStatus ?? "Inspect",
            AssetBlob: blobStr,
            Coming_From: prior?.Coming_From || "",
            Broken_AssetID: "",
            Broken_AssetNo: "",
            Broken_AssetBlob: "",
            LaydownYard: prior?.LaydownYard || formData.laydown || "",
            ID: prior?.ID,
          });
        });
      }

      setAssets(temp);
      setAssetsFetched(true);
    } catch (error) {
      console.error("Error fetching assets:", error);
      setAssets([]);
      setAssetsFetched(true);
    } finally {
      setIsLoading(false);
    }
  };

  let fetchRequestDetails = async () => {
    let payload = { ID: templateId };
    let res = await getRequestById(payload, localStorage.access_token);
    if (res.status === 200) {
      const data = res?.data?.RequestDetails || res?.data;
      setStaus(data?.Status);
      setFormData({
        rigNuber: data?.JobSiteNumber,
        laydown: data?.ShippedTo,
        addShipTo: data?.addShipTo,
        note: data?.Note,
        reason: "",
        comingfrom: "",
      });

      setTruckingToRig({
        company: data?.Company,
        driverName: data?.DriverName,
        phone: data?.PhoneNumber,
        bol: data?.BOL,
        payforTruck: data?.PayForTruck,
        po: data?.S3SPO,
      });

      setAdditionalEmailsList(
        data?.additional_email_recipients?.length
          ? data.additional_email_recipients
          : []
      );
      setVehicleFrontPreview(data?.VehicleFrontBlob);
      setVehicleBackPreview(data?.VehicleBackBlob);
      setAdditionalEmails(data?.additional_email_recipients || []);

      let assetTemp = [];
      data?.Asset?.forEach((ast, i) => {
        const blobStr =
          typeof ast?.AssetBlob === "string" ? ast.AssetBlob : "";
        const fullUrl = buildAssetPreviewUrl(blobStr);
        let obj = {
          id: `${Date.now()}-${i}`,
          name: "S3S",
          ID: ast?.ID,
          img: fullUrl,
          imgName:
            ast?.AssetNo ||
            (blobStr ? blobStr.substring(0, 20) : "") ||
            "Asset Image",
          imgPreview: fullUrl,
          value: "",
          AssetID: ast?.AssetID,
          AssetNo: ast?.AssetNo,
          rentalTicketNo:
            ast?.rentalTicketNo ?? ast?.RentalTicketNo ?? "",
          Status:
            ast?.Status ?? ast?.AssetStatus ?? ast?.status ?? "Inspect",
          AssetBlob: blobStr,
          Coming_From: ast?.Coming_From || "",
          Broken_AssetID: "",
          Broken_AssetNo: "",
          Broken_AssetBlob: "",
          LaydownYard: ast?.LaydownYard || data?.ShippedTo || "",
        };
        assetTemp.push(obj);
      });
      setAssets(assetTemp);
      setAssetsFetched(true);

      prevRigRef.current = data?.JobSiteNumber || "";
      initialLoadDoneRef.current = true;

      setAdditionaltruckingToRig({
        company: data?.ADDT_Company,
        driverName: data?.ADDT_DriverName,
        phone: data?.ADDT_PhoneNumber,
        bol: data?.ADDT_BOL,
        payforTruck: data?.ADDT_PayForTruck,
        po: data?.ADDT_S3SPO,
      });

      if (data?.Chargeback?.length) {
        setChargeBackCustomers(data.Chargeback);
      }
    }
  };

  let fetchEmail = async () => {
    let res = await getEmails(localStorage.access_token);
    if (res.data && res.data.status_code === 200) {
      setUserEmails(res.data?.data || []);
    }
  };

  // ─── FIXED: parts and locations normalized to primitive options ───
  let fetchParts = async () => {
    try {
      let res = await getParts(localStorage.access_token);
      let locationRes = await getLocations(localStorage.access_token);

      if (locationRes && locationRes.data) {
        const rawLocations = Array.isArray(locationRes.data.response_body)
          ? locationRes.data.response_body
          : [];
        const cleanLocations = rawLocations
          .map((loc) =>
            toPrimitiveOption(loc, ["Location", "LocationName", "name", "value"])
          )
          .filter(Boolean);
        setInputOptionList(dedupeOptions(cleanLocations));
      } else {
        setInputOptionList([]);
      }

      let temp = [];
      if (res?.data && Array.isArray(res.data)) {
        res.data.forEach((val) => {
          if (val?.AssetNo === null || val?.AssetNo === undefined) return;
          const label = String(val.AssetNo);
          if (!label.trim()) return;
          // Use AssetID as value when present; fall back to label so it's always primitive
          const value = val.AssetID ?? label;
          temp.push({ value, label });
        });
      }
      setPartsList(dedupeOptions(temp));
    } catch (err) {
      console.error("Error fetching parts/locations:", err);
      setPartsList([]);
      setInputOptionList([]);
    }
  };

  let handleImagePreview = (index) => {
    setShow(true);
    setSelectedPreview(index);
  };

  const handleVehiclePreview = (src, name) => {
    if (!src) return;
    setVehiclePreviewSrc(src);
    setVehiclePreviewName(name || "Vehicle Image");
    setShowVehiclePreview(true);
  };

  const handleVehiclePreviewClose = () => {
    setShowVehiclePreview(false);
    setVehiclePreviewSrc(null);
    setVehiclePreviewName("");
  };

  const handleAttachmentClick = (index) => {
    if (areAssetsLocked) return;
    fileInputRefs.current[index]?.click();
  };

  let handleAddImg = () => {
    if (areAssetsLocked) return;
    setAssets((prev) => [
      ...prev,
      {
        id: `new-${Date.now()}-${prev.length}`,
        name: "S3S",
        img: "",
        imgName: "",
        imgPreview: "",
        value: "",
        AssetID: null,
        AssetNo: "",
        rentalTicketNo: "",
        Status: "Inspect",
        Coming_From: "",
        AssetBlob: "",
        Broken_AssetID: "",
        Broken_AssetNo: "",
        Broken_AssetBlob: "",
        LaydownYard: formData.laydown || "",
      },
    ]);
  };

  let handleRemoveImg = (val) => {
    if (areAssetsLocked) return;
    if (templateId && val?.ID) {
      handleDeleteAsset(val.ID);
    }
    setAssets((prevAssets) => prevAssets.filter((item) => item.id !== val.id));
  };

  let handleDeleteAsset = async (id) => {
    let payload = { ID: id };
    let token = localStorage.access_token;
    setIsLoading(true);
    let res = await deleteAsset(payload, token);
    if (res && res.status === 200) {
      toast.dismiss();
      toast.success(res.data, { autoClose: 3000 });
    }
    setIsLoading(false);
  };

  let handleRemoveImgPreview = (index) => {
    if (areAssetsLocked) return;
    let temp = [...assests];
    temp[index].img = "";
    temp[index].imgName = "";
    temp[index].imgPreview = "";
    temp[index].AssetBlob = "";
    setAssets(temp);
  };

  let handleFromChange = (e, i) => {
    let temp = [...assests];
    temp[i].Coming_From = e.target.value;
    setAssets(temp);
  };

  const handleFileChange = async (event, index) => {
    if (areAssetsLocked) return;
    const file = event.target.files?.[0];
    if (!file) return;

    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.dismiss();
      toast.error("Only image files (PNG, JPG, JPEG, WEBP, GIF) are allowed.", { autoClose: 5000 });
      event.target.value = "";
      return;
    }

    let temp = [...assests];
    const fileUrl = URL.createObjectURL(file);
    temp[index].img = fileUrl;
    temp[index].imgName = file.name;
    temp[index].imgPreview = fileUrl;

    let data = await uploadFile(file);
    temp[index].AssetBlob = data?.data || "";
    setAssets(temp);
  };

  let uploadFile = async (file) => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("file", file, file.name);
    let res = await uploadImg(fd, localStorage.access_token);
    setIsLoading(false);
    return res;
  };

  const handleDivClick = (val) => {
    if (isLocked) return;
    val.current.click();
  };

  const handleVehicleFileChange = async (event, val) => {
    if (isLocked) return;
    const file = event?.target?.files?.[0] || event?.files?.[0];
    if (!file) return;

    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.dismiss();
      toast.error("Only image files (PNG, JPG, JPEG, WEBP, GIF) are allowed.", { autoClose: 5000 });
      if (event && event.target) event.target.value = "";
      return;
    }

    const fileUrl = URL.createObjectURL(file);

    if (val === "vehicleFrontRef") {
      setVehicleFrontName(file.name);
      setVehicleFrontPreview(fileUrl);
      let data = await uploadFile(file);
      setVehicleFrontimage(data?.data || "");
    } else if (val === "vehicleBackRef") {
      setVehicleBackName(file.name);
      setVehicleBackPreview(fileUrl);
      let data = await uploadFile(file);
      setVehicleBackimage(data?.data || "");
    } else if (val === "vehicleSide1Ref") {
      setVehicleside1Preview(fileUrl);
      let data = await uploadFile(file);
      setVehicleside1image(data?.data || "");
    } else {
      setVehicleside2Preview(fileUrl);
      let data = await uploadFile(file);
      setVehicleside2image(data?.data || "");
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let handleChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  let handleRigChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target;
    setTruckingToRig({ ...truckingToRig, [name]: value });
  };

  let handleAdditionalRigChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target;
    setAdditionaltruckingToRig({ ...additionaltruckingToRig, [name]: value });
  };

  let handleSubmit = async (type) => {
    if (isLocked) return;

    let filteredAsset = (assests || [])
      .filter((item) => item.AssetNo != null && item.AssetNo !== "")
      .map((item) => ({
        AssetID: item.AssetID ?? "",
        AssetNo: item.AssetNo,
        AssetBlob: item.AssetBlob ?? "",
        Coming_From: item.Coming_From ?? "",
        LaydownYard: item?.LaydownYard ?? "",
        rentalTicketNo: item?.rentalTicketNo ?? "",
        Status: item?.Status ?? "Inspect",
        ID: item?.ID,
      }));

    const chargebackList = Array.isArray(chargeBackCustomers)
      ? chargeBackCustomers
        .map((obj) => obj?.name)
        .filter((name) => typeof name === "string" && name.trim() !== "")
      : [];

    const requiredFields = [
      { label: "Rig/Jobsite Number", value: formData.rigNuber },
      { label: "Shipped To", value: formData.laydown },
      { label: "Trucking Company", value: truckingToRig.company },
      { label: "Driver Name", value: truckingToRig.driverName },
      { label: "Phone Number", value: truckingToRig.phone },
    ];

    for (let field of requiredFields) {
      if (
        field.value == null ||
        (typeof field.value === "string" && field.value.trim() === "") ||
        (typeof field.value === "number" && field.value === 0)
      ) {
        toast.dismiss();
        toast.warning(`Input ${field.label} field`, { autoClose: 3000 });
        return;
      }
    }

    const emailSet = new Set([
      ...(Array.isArray(additionalEmails) ? additionalEmails : []),
      ...(Array.isArray(additionalEmailsList) ? additionalEmailsList : []),
    ]);

    let payload = {
      RequestType: "RELEASE",
      Asset: filteredAsset,
      ActiveJobName: formData.rigNuber,
      AdditionalAsset: [],
      BrokenAsset: [{ AssetID: "", AssetNo: "", AssetBlob: "" }],
      Chargeback: chargebackList,
      ShippedTo: formData.laydown,
      addShipTo: formData.addShipTo,
      ShippedFrom: formData.rigNuber,
      ADDED_Because: "",
      ADDT_ShipTo: "",
      reason: "",
      Company: truckingToRig.company,
      JobSiteNumber: formData.rigNuber,
      DriverName: truckingToRig.driverName,
      PhoneNumber: truckingToRig.phone,
      BOL: truckingToRig.bol,
      PayForTruck: truckingToRig.payforTruck,
      S3SPO: truckingToRig.po,
      ADDT_Company: additionaltruckingToRig.company,
      ADDT_DriverName: additionaltruckingToRig.driverName,
      ADDT_PhoneNumber: additionaltruckingToRig.phone,
      ADDT_BOL: additionaltruckingToRig.bol,
      ADDT_PayForTruck: additionaltruckingToRig.payforTruck,
      ADDT_S3SPO: additionaltruckingToRig.po,
      VehicleFrontBlob: vehicleFrontimage || "",
      VehicleBackBlob: vehicleBackimage || "",
      VehicleSide1Blob: vehicleside1image || "",
      VehicleSide2Blob: vehicleside2image || "",
      RETURNED: "",
      ADDED_Jobsite: "",
      ModifiedByUser: localStorage.role ? localStorage.role : "",
      additional_email_recipients: [...emailSet],
    };

    if (type === "save") {
      setIsLoading(true);
      try {
        let res = await postDeploy(payload, localStorage.access_token);
        setIsLoading(false);

        if (res) {
          if (res.status === 200) {
            toast.dismiss();
            toast.success("Template data submitted!", { autoClose: 3000 });
            setTimeout(() => navigate("/dashboard"), 2000);
          } else {
            const msg =
              res?.data?.message ||
              res?.data?.error ||
              (typeof res.data === "string" ? res.data : null) ||
              `Request failed (${res.status})`;
            toast.dismiss();
            toast.error(msg, { autoClose: 5000 });
          }
        } else {
          toast.dismiss();
          toast.error("Internal server error!", { autoClose: 5000 });
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error submitting template data:", error);

        const errorMsg =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          (typeof error?.response?.data === "string"
            ? error.response.data
            : null) ||
          error?.message ||
          "Something went wrong. Please try again.";

        toast.dismiss();
        toast.error(errorMsg, { autoClose: 5000 });
      }
    } else {
      payload.RequestID = templateId;
      payload.Note = formData.note;
      delete payload.Asset;
      payload.BrokenAsset = [];
      payload.Chargeback = chargeBackCustomers.length
        ? chargeBackCustomers
        : [];

      setIsLoading(true);
      try {
        let res = await updateRequest(payload, localStorage.access_token);
        setIsLoading(false);

        if (res) {
          if (res.status === 200) {
            const successMsg =
              typeof res.data === "string"
                ? res.data
                : res?.data?.message || "Request updated successfully!";
            toast.dismiss();
            toast.success(successMsg, { autoClose: 3000 });
            fetchRequestDetails();
          } else {
            const msg =
              res?.data?.message ||
              res?.data?.error ||
              (typeof res.data === "string" ? res.data : null) ||
              `Request failed (${res.status})`;
            toast.dismiss();
            toast.error(msg, { autoClose: 5000 });
          }
        } else {
          toast.dismiss();
          toast.error("Internal server error!", { autoClose: 5000 });
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error updating request:", error);

        const errorMsg =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          (typeof error?.response?.data === "string"
            ? error.response.data
            : null) ||
          error?.message ||
          "Something went wrong. Please try again.";

        toast.dismiss();
        toast.error(errorMsg, { autoClose: 5000 });
      }
    }
  };

  const handleSelect = (selectedValue, index) => {
    if (areAssetsLocked) return;
    if (!selectedValue && selectedValue !== 0) {
      let temp = [...assests];
      temp[index].AssetID = null;
      temp[index].AssetNo = "";
      setAssets(temp);
      return;
    }

    let obj = partsList.find((val) => val.value == selectedValue);
    if (!obj) {
      obj = partsList.find((val) => val.label == selectedValue);
    }

    let temp = [...assests];
    if (!obj) return;
    temp[index].AssetID = obj.value;
    temp[index].AssetNo = obj.label;
    setAssets(temp);
  };

  let handleLaydownYardChange = (selectedValue, index) => {
    if (areAssetsLocked) return;
    setAssets((prevAssets) =>
      prevAssets.map((asset, i) =>
        i === index ? { ...asset, LaydownYard: selectedValue ?? "" } : asset
      )
    );
  };

  const handleAssetFieldChange = (field, value, index) => {
    if (areAssetsLocked) return;
    setAssets((prevAssets) =>
      prevAssets.map((asset, i) =>
        i === index ? { ...asset, [field]: value } : asset
      )
    );
  };

  let handleChargebackAdd = () => {
    if (isLocked) return;
    let temp = [...chargeBackCustomers];
    temp.push({ name: "", id: chargeBackCustomers.length + 1 });
    setChargeBackCustomers(temp);
  };

  let handleChargebackRemove = (index) => {
    if (isLocked) return;
    setChargeBackCustomers((prev) => prev.filter((val) => val.id !== index));
  };

  let handleChargeBackNameChange = (e, index) => {
    if (isLocked) return;
    let { value } = e.target;
    let temp = [...chargeBackCustomers];
    temp[index].name = value;
    setChargeBackCustomers(temp);
  };

  let handleInputSelect = (e, name) => {
    if (isLocked) return;
    setFormData({ ...formData, [name]: e });
  };

  let validateEmail = (email) => {
    if (!email) return false;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  let handleAddEmail = () => {
    if (isLocked) return;
    if (!validateEmail(additionalEmail)) {
      setAdditionalEmailError("Enter valid email id");
    } else {
      setAdditionalEmailsList((prev) => [...prev, additionalEmail]);
      setAdditionalEmail("");
    }
  };

  let handleRemoveEmail = (indexToRemove) => {
    if (isLocked) return;
    setAdditionalEmailsList((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  let handleEmailListChange = (e) => {
    if (isLocked) return;
    setAdditionalEmail(e.target.value);
    setAdditionalEmailError("");
  };

  let handleAddEmailChange = (val) => {
    if (isLocked) return;
    if (additionalEmails.includes(val)) {
      setAdditionalEmails(additionalEmails.filter((ele) => ele !== val));
    } else {
      setAdditionalEmails([...additionalEmails, val]);
    }
  };

  const handleVehicleRemove = (key) => {
    if (isLocked) return;
    switch (key) {
      case "vehicleFrontRef":
        setVehicleFrontPreview(null);
        setVehicleFrontName(null);
        setVehicleFrontimage(null);
        break;
      case "vehicleBackRef":
        setVehicleBackPreview(null);
        setVehicleBackName(null);
        setVehicleBackimage(null);
        break;
      case "vehicleSide1Ref":
        setVehicleside1Preview(null);
        setVehicleside1image(null);
        break;
      case "vehicleSide2Ref":
        setVehicleside2Preview(null);
        setVehicleside2image(null);
        break;
      default:
        break;
    }
  };

  return (
    <div className="wrapper">
      {isLoading ? <FullScreenLoader /> : null}
      <Header />
      <div className="container-layout">
        <div className="heading-section">
          <Container fluid>
            <Row>
              <Col xs="12">
                <div className="d-flex flex-wrap align-items-center">
                  <h2 className="main-title-h">Email Templates</h2>
                  {templateId ? (
                    <div className="side-viewbutton-lyt ps-4">
                      {status ? (
                        status === "Completed" ? (
                          <span className="btn-cmn-yt-2 ms-2">Completed</span>
                        ) : (
                          <span className="btn-cmn-yt-1">Request Submitted</span>
                        )
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="email-section-area">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="email-tab-wapper">
                  <div>
                    {!templateId && (
                      <div>
                        <SubHeader />
                      </div>
                    )}

                    <div className="content-tab--layout">
                      <div className="tab-items--content">
                        <Card>
                          <Card.Header className="cardheader--wgt">
                            <h3 className="heading-dep-small">{heading}</h3>
                          </Card.Header>
                          <CardBody>
                            <div className="email-shrt-disc">
                              <p className="text-black">Hello,</p>
                              <p>
                                The following Rig/Jobsite:
                                <span style={{ color: "red" }}>*</span>
                                <div className="d-inline-block mx-md-2 my-2 position-relative input-width-area dropdown-close-btn">
                                  <SearchableDropdown
                                    disabled={isLocked}
                                    options={rigOptionList}
                                    onSelect={(e) =>
                                      handleInputSelect(e, "rigNuber")
                                    }
                                    selectedValue={formData.rigNuber}
                                    placeholder="Select"
                                  />
                                  <span className="down-arrow-iconwt">
                                    <img src={downArrowIcon} alt="" />
                                  </span>
                                </div>{" "}
                                has been{" "}
                                <span className="text-bold-highlight">
                                  RELEASED
                                </span>{" "}
                                by the Customer. All of the assets have been Rig
                                Down in the Portal: Tech Ops module and are
                                being shipped today to:
                                <span style={{ color: "red" }}>*</span>
                                <div className="d-inline-block mx-md-2 my-2 position-relative input-width-area dropdown-close-btn">
                                  <SearchableDropdown
                                    disabled={isLocked}
                                    options={inputOptionList}
                                    onSelect={(e) =>
                                      handleInputSelect(e, "laydown")
                                    }
                                    selectedValue={formData.laydown}
                                    placeholder="Select"
                                  />
                                  <span className="down-arrow-iconwt">
                                    <img src={downArrowIcon} alt="" />
                                  </span>
                                </div>
                                {rentalTicketNumber && (
                                  <span className="rental-ticket-badge">
                                    RENTAL TICKET NO : {rentalTicketNumber}
                                  </span>
                                )}
                              </p>{" "}
                            </div>

                            <div className="addition-level-mts">
                              <div className="container-wgtrow">
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item eventKey="0">
                                    <Accordion.Header className="heading-lbl-waps">
                                      Add additional email IDs:{" "}
                                      <span className="short-linetxt-hd">
                                        <i className="fas fa-exclamation-circle me-1"></i>{" "}
                                        BC Admins automatically receive all
                                        notifications for requests submitted
                                        through this application
                                      </span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <div className="wrapper-grid--colart">
                                        <Row>
                                          {userEmails &&
                                            userEmails.map((val, i) => (
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                key={i}
                                              >
                                                <div className="list-check-filed-wp">
                                                  <h3 className="main-head-lst">
                                                    {val.key}
                                                  </h3>
                                                  <ul className="mult-check-wps--emnt">
                                                    {val.values &&
                                                      val.values.map(
                                                        (ele, index) => (
                                                          <li
                                                            className="list-checkwps-dep"
                                                            key={index}
                                                          >
                                                            <input
                                                              disabled={isLocked}
                                                              checked={additionalEmails.includes(
                                                                ele
                                                              )}
                                                              onChange={() =>
                                                                handleAddEmailChange(
                                                                  ele
                                                                )
                                                              }
                                                              type="checkbox"
                                                              className="check-lst-wp"
                                                            />
                                                            <span className="label-lst-nvm">
                                                              {ele}
                                                            </span>
                                                          </li>
                                                        )
                                                      )}
                                                  </ul>
                                                </div>
                                              </Col>
                                            ))}
                                        </Row>

                                        <Row>
                                          <Col xs={12} md={6}>
                                            <div className="addition-field-requre">
                                              <div className="field-wps-mt">
                                                <label className="label-txt--add">
                                                  Add the additional email ID{" "}
                                                  <i></i>
                                                </label>
                                                <div className="position-relative d-flex">
                                                  <input
                                                    disabled={isLocked}
                                                    onChange={(e) =>
                                                      handleEmailListChange(e)
                                                    }
                                                    value={additionalEmail}
                                                    name="additionalEmail"
                                                    type="email"
                                                    placeholder="Enter the Email ID"
                                                    className="form-control control-addtion-wp"
                                                  />
                                                  <button
                                                    onClick={handleAddEmail}
                                                    disabled={isLocked}
                                                    className="add-btn-mt"
                                                  >
                                                    ADD
                                                  </button>
                                                  <span className="msg-icon-wtp">
                                                    <img
                                                      src={messageIcon}
                                                      alt=""
                                                    />
                                                  </span>
                                                </div>
                                              </div>

                                              {additionalEmailError ? (
                                                <p
                                                  style={{
                                                    fontSize: "12px",
                                                    color: "red",
                                                  }}
                                                >
                                                  {additionalEmailError}
                                                </p>
                                              ) : null}

                                              <div className="list-add-ftm">
                                                <ul className="mult-lstmtv">
                                                  {additionalEmailsList.length
                                                    ? additionalEmailsList.map(
                                                      (val, i) => (
                                                        <li
                                                          className="lst-bxwp"
                                                          key={i}
                                                        >
                                                          <span className="icon-check-wth">
                                                            <img
                                                              src={checkIcon}
                                                              alt="icon"
                                                            />
                                                          </span>
                                                          {val}
                                                          {!isLocked && (
                                                            <button className="btn border-0 p-0 btn-cross-adnt">
                                                              <img
                                                                onClick={() =>
                                                                  handleRemoveEmail(
                                                                    i
                                                                  )
                                                                }
                                                                src={
                                                                  crossIconWeb
                                                                }
                                                                alt="icon"
                                                              />
                                                            </button>
                                                          )}
                                                        </li>
                                                      )
                                                    )
                                                    : null}
                                                </ul>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </div>
                            </div>

                            <div className="fixed-scroll-row">
                              <Row>
                                <Col
                                  xs={12}
                                  md={8}
                                  className="card-space-bottom"
                                >
                                  <Card className="card-stage-bg">
                                    <CardBody>
                                      <Row>
                                        <Col xs={12} md={6}>
                                          <Card className="mb-3 card-height-equal">
                                            <CardBody>
                                              <div className="emial-heading-wt">
                                                <h3 className="heading-yt-wp">
                                                  Assets
                                                </h3>
                                              </div>

                                              {!formData.rigNuber ? (
                                                <div className="assets-empty-state">
                                                  <div className="assets-empty-icon">
                                                    <img
                                                      src={placeholderImgLarge}
                                                      alt="No assets"
                                                    />
                                                  </div>
                                                  <p className="assets-empty-title">
                                                    Select From data
                                                  </p>
                                                  <p className="assets-empty-subtitle">
                                                    Assets will appear here
                                                    once a Rig/Jobsite and
                                                    Laydown are selected above.
                                                  </p>
                                                </div>
                                              ) : (
                                                <div className="assets-list-container">
                                                  {assests.map((val, index) => (
                                                    <div
                                                      className="assets-add"
                                                      key={val.id}
                                                    >
                                                      <div className="asset-row">
                                                        <div className="asset-select-group">
                                                          {/* ===== Asset Selection Dropdown ===== */}
                                                          <div className="asset-select-block">
                                                            <label className="asset-field-label">
                                                              Asset #
                                                            </label>
                                                            <div className="dropdown-row">
                                                              <div className="dropdown-wrapper">
                                                                <SearchableDropdown
                                                                  disabled={areAssetsLocked}
                                                                  options={
                                                                    partsList
                                                                  }
                                                                  onSelect={(
                                                                    e
                                                                  ) =>
                                                                    handleSelect(
                                                                      e,
                                                                      index
                                                                    )
                                                                  }
                                                                  placeholder="Select Asset"
                                                                  selectedValue={
                                                                    val.AssetNo ||
                                                                    val.AssetID ||
                                                                    ""
                                                                  }
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>

                                                          {/* ===== Rental Ticket Number ===== */}
                                                          {/* <div className="asset-select-block">
                                                            <label
                                                              className="asset-field-label"
                                                              htmlFor={`rental-ticket-${val.id}`}
                                                            >
                                                              Rental Ticket No.1
                                                            </label>
                                                            <input
                                                              id={`rental-ticket-${val.id}`}
                                                              type="text"
                                                              className="form-control asset-native-control"
                                                              placeholder="Enter rental ticket number"
                                                              value={val.rentalTicketNo ?? ""}
                                                              disabled={areAssetsLocked}
                                                              onChange={(e) =>
                                                                handleAssetFieldChange(
                                                                  "rentalTicketNo",
                                                                  e.target.value,
                                                                  index
                                                                )
                                                              }
                                                            />
                                                          </div> */}

                                                          {/* ===== Laydown Dropdown + Actions ===== */}
                                                          <div className="asset-select-block">
                                                            <label className="asset-field-label">
                                                              Laydown Yard
                                                            </label>
                                                            <div className="dropdown-row">
                                                              <div className="dropdown-wrapper">
                                                                <SearchableDropdown
                                                                  disabled={areAssetsLocked}
                                                                  options={
                                                                    inputOptionList
                                                                  }
                                                                  onSelect={(
                                                                    e
                                                                  ) =>
                                                                    handleLaydownYardChange(
                                                                      e,
                                                                      index
                                                                    )
                                                                  }
                                                                  placeholder="Search laydown..."
                                                                  selectedValue={
                                                                    val.LaydownYard
                                                                  }
                                                                />
                                                              </div>
                                                              <div className="asset-actions">
                                                                {!areAssetsLocked && (
                                                                  <button
                                                                    type="button"
                                                                    className="btn btn-wt--comn"
                                                                    onClick={() =>
                                                                      handleAttachmentClick(
                                                                        index
                                                                      )
                                                                    }
                                                                    title="Attach file"
                                                                  >
                                                                    <img
                                                                      src={
                                                                        attachmentIcon
                                                                      }
                                                                      alt="Attach"
                                                                    />
                                                                  </button>
                                                                )}

                                                                {!areAssetsLocked && (
                                                                  <button
                                                                    type="button"
                                                                    className="btn btn-wt--comn btn-remove-asset"
                                                                    onClick={() =>
                                                                      handleRemoveImg(
                                                                        val
                                                                      )
                                                                    }
                                                                    title="Remove asset"
                                                                  >
                                                                    <img
                                                                      src={
                                                                        deleteIcon
                                                                      }
                                                                      alt="Remove"
                                                                    />
                                                                  </button>
                                                                )}

                                                                <input
                                                                  type="file"
                                                                  accept={
                                                                    ALLOWED_IMAGE_ACCEPT
                                                                  }
                                                                  ref={(el) =>
                                                                  (fileInputRefs.current[
                                                                    index
                                                                  ] = el)
                                                                  }
                                                                  style={{
                                                                    display:
                                                                      "none",
                                                                  }}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFileChange(
                                                                      e,
                                                                      index
                                                                    )
                                                                  }
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>

                                                          {/* ===== Asset Status ===== */}
                                                          {/* ===== Custom Asset Status Dropdown ===== */}


                                                          {/* <div className="asset-select-block">
                                                            <label className="asset-field-label">
                                                              Status
                                                            </label>

                                                            <div className="custom-status-dropdown">
                                                              <button
                                                                type="button"
                                                                className={`status-dropdown-trigger status-${String(
                                                                  val.Status || "Inspect"
                                                                ).toLowerCase().replace(/\s+/g, "-")}`}
                                                                disabled={areAssetsLocked}
                                                                aria-expanded={openStatusDropdown === val.id}
                                                                onClick={() =>
                                                                  setOpenStatusDropdown(
                                                                    openStatusDropdown === val.id ? null : val.id
                                                                  )
                                                                }
                                                              >
                                                                <span className="status-selected-value">
                                                                  <span className="status-dot" />
                                                                  {val.Status || "Inspect"}
                                                                </span>

                                                                <span className="status-dropdown-arrow">
                                                                  <i className="fas fa-chevron-down" />
                                                                </span>
                                                              </button>

                                                              {openStatusDropdown === val.id && !areAssetsLocked && (
                                                                <div className="status-dropdown-menu">
                                                                  {ASSET_STATUS_OPTIONS.map((option) => (
                                                                    <button
                                                                      type="button"
                                                                      key={option}
                                                                      className={`status-option ${val.Status === option ? "active" : ""
                                                                        }`}
                                                                      onClick={() => {
                                                                        handleAssetFieldChange("Status", option, index);
                                                                        setOpenStatusDropdown(null);
                                                                      }}
                                                                    >
                                                                      <span className="status-radio">
                                                                        {val.Status === option && (
                                                                          <span className="status-radio-inner" />
                                                                        )}
                                                                      </span>

                                                                      <span>{option}</span>
                                                                    </button>
                                                                  ))}
                                                                </div>
                                                              )}
                                                            </div>
                                                          </div> */}

                                                        </div>
                                                      </div>

                                                      {val.imgName && (
                                                        <div className="asset-attachment-preview">
                                                          <div className="img-bx-wgt">
                                                            <img
                                                              className="place-img--emt"
                                                              src={
                                                                placeholderImg
                                                              }
                                                              alt=""
                                                            />
                                                            <span
                                                              className="img-txt-name"
                                                              onClick={() =>
                                                                handleImagePreview(
                                                                  index
                                                                )
                                                              }
                                                              title={
                                                                val.imgName
                                                              }
                                                            >
                                                              {val.imgName}
                                                            </span>
                                                            {!areAssetsLocked && (
                                                              <span
                                                                onClick={() =>
                                                                  handleRemoveImgPreview(
                                                                    index
                                                                  )
                                                                }
                                                                className="cross-img-btn"
                                                                title="Remove attachment"
                                                              >
                                                                <img
                                                                  src={
                                                                    crossIcon
                                                                  }
                                                                  alt="Remove"
                                                                />
                                                              </span>
                                                            )}
                                                          </div>
                                                        </div>
                                                      )}
                                                    </div>
                                                  ))}

                                                  {/* ===== Add Asset button at bottom ===== */}
                                                  {!areAssetsLocked && (
                                                    <button
                                                      type="button"
                                                      className="btn btn-add-asset"
                                                      onClick={handleAddImg}
                                                      title="Add Asset"
                                                    >
                                                      <img
                                                        src={plusIcon}
                                                        alt="Add"
                                                      />
                                                      <span>Add Asset</span>
                                                    </button>
                                                  )}

                                                  {/* Info empty state (create mode only) */}
                                                  {!templateId &&
                                                    assests.length === 0 && (
                                                      <div className="assets-empty-state assets-empty-state--info">
                                                        <p className="assets-empty-subtitle">
                                                          No assets yet. Click{" "}
                                                          <strong>
                                                            Add Asset
                                                          </strong>{" "}
                                                          to add one manually.
                                                        </p>
                                                      </div>
                                                    )}
                                                </div>
                                              )}
                                            </CardBody>
                                          </Card>
                                        </Col>

                                        <Col xs={12} md={6}>
                                          <Card className="mb-3 card-height-equal">
                                            <CardBody>
                                              <div className="mt-wap--gtr">
                                                <h3 className="heading-yt-wp">
                                                  Trucking to Rig
                                                </h3>
                                                <div className="form-card--lyt">
                                                  <Form>
                                                    {[
                                                      {
                                                        label: "Company",
                                                        name: "company",
                                                        required: true,
                                                        placeholder:
                                                          "Input Company",
                                                      },
                                                      {
                                                        label: "Driver Name",
                                                        name: "driverName",
                                                        required: true,
                                                        placeholder:
                                                          "Input Name",
                                                      },
                                                      {
                                                        label: "Phone Number",
                                                        name: "phone",
                                                        required: true,
                                                        placeholder:
                                                          "Input Phone",
                                                      },
                                                      {
                                                        label:
                                                          "Bill of Lading Number (BOL)",
                                                        name: "bol",
                                                        required: false,
                                                        placeholder:
                                                          "Input BOL",
                                                      },
                                                      {
                                                        label:
                                                          "Pay for the Truck",
                                                        name: "payforTruck",
                                                        required: false,
                                                        placeholder:
                                                          "Input Pay",
                                                      },
                                                      {
                                                        label: "S3S PO#",
                                                        name: "po",
                                                        required: false,
                                                        placeholder:
                                                          "Input Po",
                                                      },
                                                    ].map((f) => (
                                                      <Form.Group
                                                        className="mb-3"
                                                        key={f.name}
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          {f.label}{" "}
                                                          {f.required && (
                                                            <span
                                                              style={{
                                                                color: "red",
                                                              }}
                                                            >
                                                              *
                                                            </span>
                                                          )}
                                                        </Form.Label>
                                                        <div className="filed-group-control">
                                                          <Form.Control
                                                            disabled={isLocked}
                                                            onChange={
                                                              handleRigChange
                                                            }
                                                            name={f.name}
                                                            value={
                                                              truckingToRig[
                                                              f.name
                                                              ]
                                                            }
                                                            type="text"
                                                            placeholder={
                                                              f.placeholder
                                                            }
                                                            className="input-vt-text"
                                                          />
                                                        </div>
                                                      </Form.Group>
                                                    ))}
                                                  </Form>
                                                </div>
                                              </div>
                                            </CardBody>
                                          </Card>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                </Col>

                                <Col xs={12} md={4}>
                                  <Attachments
                                    vehicleFrontRef={vehicleFrontRef}
                                    vehicleBackRef={vehicleBackRef}
                                    vehicleSide1Ref={vehicleSide1Ref}
                                    vehicleSide2Ref={vehicleSide2Ref}
                                    handleVehicleFileChange={
                                      handleVehicleFileChange
                                    }
                                    handleDivClick={handleDivClick}
                                    vehicleFrontPreview={vehicleFrontPreview}
                                    vehicleBackPreview={vehicleBackPreview}
                                    vehicleside1Preview={vehicleside1Preview}
                                    vehicleside2Preview={vehicleside2Preview}
                                    vehicleFrontName={vehicleFrontName}
                                    vehicleBackName={vehicleBackName}
                                    handleVehiclePreview={
                                      handleVehiclePreview
                                    }
                                    templateId={templateId}
                                    isLocked={isLocked}
                                    handleVehicleRemove={handleVehicleRemove}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </CardBody>
                        </Card>

                        <div className="bottom-submit-action">
                          <Row>
                            <Col xs={12} md={6}>
                              {templateId && !isLocked ? (
                                <div className="note-content-text">
                                  <Form.Label
                                    style={{ color: "#092e56" }}
                                    className="label-txt-vl"
                                  >
                                    Comment
                                  </Form.Label>
                                  <textarea
                                    rows={5}
                                    placeholder={
                                      templateId
                                        ? "Enter note"
                                        : "Text input"
                                    }
                                    disabled={!templateId || isCompleted}
                                    name="note"
                                    value={formData.note}
                                    onChange={handleChange}
                                    className="form-select-value form-control"
                                  />
                                </div>
                              ) : null}
                            </Col>

                            <Col xs={12} md={6}>
                              <div className="text-start text-md-end mt-3 mt-md-0">
                                {templateId && !isLocked ? (
                                  <button
                                    onClick={() => handleSubmit("update")}
                                    type="submit"
                                    className="btn btn-submit-btn me-2"
                                  >
                                    Save
                                  </button>
                                ) : null}

                                {templateId ? (
                                  isAdmin && !isCompleted ? (
                                    <button
                                      onClick={handleComplete}
                                      type="submit"
                                      className="btn btn-submit-btn"
                                    >
                                      Mark as complete
                                    </button>
                                  ) : null
                                ) : (
                                  <button
                                    onClick={() => handleSubmit("save")}
                                    type="submit"
                                    className="btn btn-submit-btn ms-2"
                                  >
                                    Submit
                                  </button>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* Assets Preview Modal */}
      <Modal
        show={show}
        size="lg"
        aria-labelledby="asset-preview-title"
        centered
        onHide={handleClose}
        contentClassName="asset-preview-modal-content"
        dialogClassName="asset-preview-modal-dialog"
        backdropClassName="asset-preview-backdrop"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="asset-preview-modal-header border-0"
        >
          <Modal.Title
            id="asset-preview-title"
            className="asset-preview-modal-title"
          >
            <span className="asset-preview-title-icon">
              <i className="fas fa-file-image"></i>
            </span>
            <span className="asset-preview-title-text">
              Asset Attachment
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="asset-preview-modal-body">
          {(() => {
            const currentItem = assests[selectedPreview];
            const previewSrc = currentItem?.imgPreview || "";
            const previewName = currentItem?.imgName || "Asset Image";

            return (
              <>
                <div className="asset-preview-image-wrapper">
                  {previewSrc ? (
                    <img
                      src={previewSrc}
                      alt={previewName}
                      className="asset-preview-image"
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                      }}
                    />
                  ) : (
                    <div className="asset-preview-empty">
                      <i className="fas fa-image fa-3x mb-3"></i>
                      <p>No image to preview</p>
                    </div>
                  )}
                </div>

                {previewSrc && (
                  <div className="asset-preview-footer">
                    <span
                      className="asset-preview-filename"
                      title={previewName}
                    >
                      <i className="fas fa-paperclip me-2"></i>
                      {previewName}
                    </span>
                    <a
                      href={previewSrc}
                      download={previewName}
                      className="asset-preview-download-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-download me-2"></i>
                      Download
                    </a>
                  </div>
                )}
              </>
            );
          })()}
        </Modal.Body>
      </Modal>

      {/* Vehicle Preview Modal */}
      <Modal
        show={showVehiclePreview}
        size="lg"
        aria-labelledby="vehicle-preview-title"
        centered
        onHide={handleVehiclePreviewClose}
        contentClassName="vehicle-preview-modal-content"
        dialogClassName="vehicle-preview-modal-dialog"
        backdropClassName="vehicle-preview-backdrop"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="vehicle-preview-modal-header border-0"
        >
          <Modal.Title
            id="vehicle-preview-title"
            className="vehicle-preview-modal-title"
          >
            <span className="vehicle-preview-title-icon">
              <i className="fas fa-image"></i>
            </span>
            <span className="vehicle-preview-title-text">
              {vehiclePreviewName || "Vehicle Image Preview"}
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="vehicle-preview-modal-body">
          <div className="vehicle-preview-image-wrapper">
            {vehiclePreviewSrc ? (
              <img
                src={vehiclePreviewSrc}
                alt={vehiclePreviewName || "Vehicle preview"}
                className="vehicle-preview-image"
              />
            ) : (
              <div className="vehicle-preview-empty">
                <i className="fas fa-image fa-3x mb-3"></i>
                <p>No image to preview</p>
              </div>
            )}
          </div>

          {vehiclePreviewSrc && (
            <div className="vehicle-preview-footer">
              <span
                className="vehicle-preview-filename"
                title={vehiclePreviewName}
              >
                <i className="fas fa-paperclip me-2"></i>
                {vehiclePreviewName || "Vehicle Image"}
              </span>
              <a
                href={vehiclePreviewSrc}
                download={vehiclePreviewName || "vehicle-image"}
                className="vehicle-preview-download-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-download me-2"></i>
                Download
              </a>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <MobileFooter />
    </div>
  );
}

export default Release;